import { render } from "./App.vue?vue&type=template&id=532ca886"
const script = {}

import "./App.vue?vue&type=style&index=0&id=532ca886&lang=css"

import exportComponent from "/Users/subahan.herekar/Downloads/EditAssist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__